import React, { FC } from 'react'
import Link from 'next/link'
import styles from './SubMenu.module.scss'
import { ISubmenuItem } from '@/src/assets/interfaces/menuInterface'

type TSubNavigation = {
    isActive: boolean
    setIsNavActive: (isNavActive: boolean) => void
    className: string
    subMenu: ISubmenuItem[]
}

const SubMenu: FC<TSubNavigation> = ({subMenu, className, isActive, setIsNavActive}) => {
    
    const showSubNav = isActive && styles['subnav__show']

    return (
        <ul className={`${styles.subnav__list} ${className} ${showSubNav}`}>
            {
                subMenu.map(item => {
                    const target = item.internalLink?.newWindow ? '_blank' : (item.externalUrl?.newWindow ? '_blank' : undefined)
                    return (
                        <li key={item._key} className={styles.subnav__item}>
                            <Link 
                                href={item.internalLink?.link ? `${item.internalLink.link}` : (item.externalUrl?.url ?? '/')}
                                target={target}
                                rel={target ? "noopener noreferrer" : undefined}
                                onClick={() => setIsNavActive(false)}
                            >
                                {item.subMenuItemName}
                            </Link>
                        </li>
                    )
                 }
                    
                )
            }
        </ul>
    )
}

export default SubMenu